import { render } from "./Home.vue?vue&type=template&id=49fda7ca&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=49fda7ca&scoped=true&lang=css"

import exportComponent from "/home/user/mydid-badgechecker-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49fda7ca"]])

export default __exports__